import { priceSurveyApi } from '@/config/axios/index';

export default {
  getPriceSurveyCategoriesList() {
    return priceSurveyApi({
      method: 'GET',
      url: 'api/v1/survey-category',
    });
  },

  getPriceSurveyListByCategory(slug, params) {
    return priceSurveyApi({
      method: 'GET',
      url: `api/v1/survey-category/${slug}/survey`,
      params,
    });
  },

  getPriceSurveyDetails(slug) {
    return priceSurveyApi({
      method: 'GET',
      url: `api/v1/survey/${slug}`,
    });
  },

  getPriceSurveyStore(slug, id) {
    return priceSurveyApi({
      method: 'GET',
      url: `api/v1/survey/${slug}/store/${id}`,
    });
  },

  getPriceSurveySpecification(slug, id) {
    return priceSurveyApi({
      method: 'GET',
      url: `api/v1/survey/${slug}/specification/${id}`,
    });
  },

  getPriceSurveyItemHistory(slug, item, store) {
    return priceSurveyApi({
      method: 'GET',
      url: `api/v1/survey/${slug}/specification/${item}/store/${store}`,
    });
  },
};
